import { Navigate, Route, Routes } from "react-router-dom";
import Display from "./components/Display";
import Admin from "./components/Admin";
import GalleryFrame from "./components/GalleryFrame";
import SearchFrame from "./components/SearchFrame";
import MapFrame from "./components/MapFrame";

export default function App() {
  return <Routes>
    <Route path="/display" element={<Display />} />
    <Route path="/gallery-frame" element={<GalleryFrame />} />
    <Route path="/gallery/:clientId" element={<GalleryFrame />} />
    <Route path="/search-frame" element={<SearchFrame />} />
    <Route path="/map-frame" element={<MapFrame />} />
    <Route path="/admin" element={<Admin />} />
    <Route path="*" element={<Navigate to="/display" replace />} />
  </Routes>;
}
